import React from "react";
import { motion } from "framer-motion";
import { Clock, Shield, Sparkles } from "lucide-react";

const EmotionalSection = () => {
  return (
    <section className="section-spacing bg-slate-950" data-testid="emotional-section">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-lg md:text-xl text-slate-300 space-y-4 mb-10">
            <p className="text-slate-400">Over time, life gets busy.</p>
            <p className="text-slate-400">Dust, crumbs, stains, and road grime slowly build up.</p>
            <p className="text-cyan-400 font-medium text-xl md:text-2xl">We refine and maintain without you lifting a finger.</p>
          </div>

          {/* Brand Values */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            {[
              { icon: Clock, title: "Protect Your Time", desc: "We come to you, wherever you are" },
              { icon: Shield, title: "Protect Your Investment", desc: "Professional care extends vehicle life" },
              { icon: Sparkles, title: "Protect Your Pride", desc: "Drive with confidence every day" }
            ].map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="glass rounded-2xl p-6"
              >
                <item.icon className="w-10 h-10 text-cyan-400 mx-auto mb-4" />
                <h3 className="font-bold text-lg mb-2">{item.title}</h3>
                <p className="text-slate-400 text-sm">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default EmotionalSection;
